module.exports = __webpack_public_path__ + "static/media/JA.f8dc0f04.svg";